import { Navigate } from 'react-router-dom';

interface RequireRoleProps {
  children: JSX.Element;
  role: 'Guest' | 'Consumer' | 'Spot' | 'Maker' | 'Support' | 'Organizer';
  allowedRoles: Array<string | null>;
  redirection?: string;
}

export function RequireRole(props: Readonly<RequireRoleProps>) {
  const { children, role, allowedRoles, redirection } = props;

  // handle Guest user or Consumer account
  if (!allowedRoles.includes(role) && ['Guest', 'Consumer'].includes(role)) {
    import.meta.env.DEV &&
      console.log('[RequireRole]: redirect to "/spots (Guest or Consumer)"', role, allowedRoles);
    return <Navigate to="/spots" replace />;
  }

  // handle Spot connected account
  if (!allowedRoles.includes(role) && role === 'Spot') {
    import.meta.env.DEV && console.log('[RequireRole]: redirect to "/me (Spot)"', role, allowedRoles);
    return <Navigate to="/me" replace />;
  }

  if (redirection) {
    import.meta.env.DEV && console.log('[RequireRole]: redirect to "redirection"', role, allowedRoles);
    return <Navigate to={redirection} replace />;
  }

  // import.meta.env.DEV && console.log('[RequireRole]: ALL GOOD!');
  return children;
}

interface RequireMeRoleProps {
  children: JSX.Element;
  role: 'Guest' | 'Consumer' | 'Spot' | 'Maker' | 'Support' | 'Organizer';
  allowedRoles: Array<string | null>;
  redirection?: string;
}

export function RequireMeRole(props: Readonly<RequireMeRoleProps>) {
  const { children, role, allowedRoles, redirection } = props;

  if (!role) {
    import.meta.env.DEV &&
      console.log('[RequireMeRole]: redirect to "/spots (missing role)"', role, allowedRoles);
    return <Navigate to="/spots" replace />;
  }

  // handle Guest user or Consumer account
  if (!allowedRoles.includes(role) && ['Guest', 'Consumer'].includes(role)) {
    import.meta.env.DEV && console.log('[RequireMeRole]: redirect to "/spots"', role, allowedRoles);
    return <Navigate to="/spots" replace />;
  }

  // handle Spot account
  if (!allowedRoles.includes(role) && role === 'Spot') {
    import.meta.env.DEV && console.log('[RequireMeRole]: redirect to "/me"', role, allowedRoles);
    return <Navigate to="/me" replace />;
  }

  if (redirection) {
    import.meta.env.DEV && console.log('[RequireMeRole]: redirect to "redirection"', role, allowedRoles);
    return <Navigate to={redirection} replace />;
  }

  // import.meta.env.DEV && console.log('[RequireMeRole]: ALL GOOD!');
  return children;
}
